import React from 'react';
import PropTypes from 'prop-types';
import { getImageURLForFetch } from '../../utils';
import getInitials from '../../utils/getInitials';
import Avatar from '@material-ui/core/Avatar';


const AvatarWrapper = ({ imageUrl, name, servedFromWebpack, ...rest }) => (
  <Avatar src={servedFromWebpack ? imageUrl : getImageURLForFetch(imageUrl)} {...rest}>
    {getInitials(name)}
  </Avatar>
);

AvatarWrapper.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  servedFromWebpack: PropTypes.bool,
};

export default AvatarWrapper;
